import React, { Fragment,useEffect  } from 'react';
import PageTitle from '../../components/pagetitle/PageTitle';
import Scrollbar from '../../components/scrollbar/scrollbar';
import CtaSection from '../../components/CtaSection/CtaSection';
import ContactSection from '../../components/ContactSection';

const ContactPage = (props) => {
    useEffect(() => {
        window.scrollTo(0, 500);
      }, []);

    return (
        <Fragment>
            {/* <Header /> */}
            <main className="page_content about-page">
                <PageTitle pageTitle={'Contact Us'} pagesub={''} pageTop={''} />
                <ContactSection />
                <CtaSection />
            </main>
            <Scrollbar />
        </Fragment>
    )
};

export default ContactPage;